if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      window.addEventListener('shopify:section:load', e => {
        this.initSlider(swiperOptions);
      });
    }

    initSlider(swiperOptions) {
      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1,
        resistanceRatio: 0.72,
        loop: swiperOptions.loop || false,
        allowTouchMove: swiperOptions.allowTouchMove || true,
        autoplay: swiperOptions.autoplay || false,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 'auto',
            loop: swiperOptions.loopDesktop || swiperOptions.loop || false,
          }
        }
      };

      this.slider = new Swiper(this, sliderOptions);

      // Auto-pause on hover, resume on leave (unless manually paused)
      if (sliderOptions.autoplay) {
        var hoverTarget = this.closest('.announcement-bar__wrapper') || this;
        var self = this;
        hoverTarget.addEventListener('mouseenter', function() {
          if (self._manuallyPaused) return;
          if (self.slider && self.slider.autoplay.running) {
            self.slider.autoplay.stop();
            self._wasAutopaused = true;
          }
        });
        hoverTarget.addEventListener('mouseleave', function() {
          if (self._manuallyPaused) return;
          if (self.slider && self._wasAutopaused) {
            self.slider.autoplay.start();
            self._wasAutopaused = false;
          }
        });
      }
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
